import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight, Sparkles } from "lucide-react";
import PublicLayout from "@/components/PublicLayout";
import { api, money } from "@/lib/api";

export default function Services() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/services").then(({ data }) => setItems(data)); }, []);
  const resolve = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
  return (
    <PublicLayout>
      <section className="container-x pt-16 pb-10">
        <div className="overline mb-4">Services</div>
        <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter text-ink-900">Done-with-you AI engagements.</h1>
        <p className="mt-6 text-ink-700 max-w-2xl leading-relaxed">Beyond the courses. When you need Niraj and his team to design, build, or advise on an AI-powered system for your business — pick the engagement that fits.</p>
      </section>
      <section className="container-x pb-24">
        {items.length === 0 ? (
          <div className="glass rounded-2xl p-10 text-center text-ink-600" data-testid="services-empty">
            <Sparkles className="w-6 h-6 text-gold mx-auto mb-3" />
            No services listed yet. Check back soon.
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="services-grid">
            {items.map((s) => (
              <article key={s.service_id} className="glass rounded-2xl p-8 flex flex-col group hover:border-gold/40 transition-colors" data-testid={`service-card-${s.slug}`}>
                {s.thumbnail && (
                  <div className="mb-6 aspect-square w-32 rounded-xl overflow-hidden border border-ink-900/10">
                    <img src={resolve(s.thumbnail)} alt={s.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                )}
                <div className="overline mb-2">{s.duration || "Custom engagement"}</div>
                <h3 className="font-display text-2xl font-bold text-ink-900">{s.title}</h3>
                <p className="mt-3 text-ink-700 text-sm leading-relaxed">{s.short_description}</p>
                {s.features?.length > 0 && (
                  <ul className="mt-5 space-y-2">
                    {s.features.map((f, i) => (
                      <li key={i} className="flex gap-2 items-start text-sm text-ink-700"><Check className="w-4 h-4 text-gold mt-0.5 shrink-0" /><span>{f}</span></li>
                    ))}
                  </ul>
                )}
                <div className="mt-auto pt-6 mt-6 border-t border-ink-900/10">
                  <div className="flex items-baseline gap-3 flex-wrap">
                    <span className="font-display text-4xl md:text-5xl font-bold text-ink-900 leading-none" data-testid={`service-price-${s.slug}`}>
                      {s.price ? money(s.price) : "On request"}
                    </span>
                    {s.original_price && s.original_price > s.price ? (
                      <span className="text-base text-ink-500 line-through">{money(s.original_price)}</span>
                    ) : null}
                    {s.billing_period && s.billing_period !== "one_time" && s.billing_period !== "quote" && (
                      <span className="text-xs uppercase tracking-wider text-gold-600">/ {s.billing_period}</span>
                    )}
                  </div>
                  {(s.price_note || (s.billing_period === "quote" && !s.price)) && (
                    <div className="text-xs text-ink-500 mt-2">{s.price_note || "custom quote"}</div>
                  )}
                  <Link to={s.cta_link || "/contact"} className="btn-neon w-full mt-5 !py-3 text-sm justify-center" data-testid={`service-cta-${s.slug}`}>
                    {s.cta_label || "Enquire"} <ArrowRight className="w-4 h-4 ml-1" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </PublicLayout>
  );
}
